import { MultiSelectConditionPanel } from '@/components/conditions/conditionComponents';
import { Icon } from '@/components/shared/icon';
import type { MultiSelectConditionComponentProps } from '@/types/advanceFilter';

import {
  DETECTOR_OPTIONS,
  SECURITY_SCAN_CONCLUSION_OPTIONS,
} from './detectorOptions';

const detectorTypeOptions = DETECTOR_OPTIONS.map(({ id, name, icon }) => ({
  id,
  name,
  Image: <Icon iconClass={icon} />,
}));

const threatFindingOptions = SECURITY_SCAN_CONCLUSION_OPTIONS.map(
  ({ id, name, icon }) => ({
    id,
    name,
    Image: <Icon iconClass={icon} />,
  })
);

export const DetectionCategoryCondition = (
  props: MultiSelectConditionComponentProps
) => (
  <MultiSelectConditionPanel
    {...props}
    showAddNewButton={false}
    showSearchBox={false}
    isLoading={false}
    entityName='detection category'
    options={detectorTypeOptions}
  />
);

export const ThreatFindingCondition = (
  props: MultiSelectConditionComponentProps
) => (
  <MultiSelectConditionPanel
    {...props}
    showAddNewButton={false}
    showSearchBox={false}
    isLoading={false}
    entityName='threat finding'
    options={threatFindingOptions}
  />
);
